import { useSprintQuery } from "sprint-common-web";

import { useFileRecordApi } from "../../../../common/api/master-api/file-records/useFileRecordApi";
import { FileRecordDetails, mapToFileRecordDetails } from "../../../common/file-record-details/FileRecordDetails";
import { FileRecordQueryKey } from "../../../common/file-record-details/FileRecordQueryKey";

export const useFileRecordDetails = (fileRecordId?: string) => {
    const { getFileRecordDetails } = useFileRecordApi();

    return useSprintQuery<FileRecordDetails | undefined>({
        queryKey: [FileRecordQueryKey.FileRecordDetails, fileRecordId],
        enabled: !!fileRecordId,
        queryFn: async (): Promise<FileRecordDetails | undefined> => {
            if (!fileRecordId) {
                return undefined;
            }

            const response = await getFileRecordDetails({ fileRecordId });

            return mapToFileRecordDetails(response);
        }
    });
};
